import React, {FC} from 'react';
import {LocalizationProvider, DateTimePicker as MUIDateTimePicker} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment from 'moment-timezone';

/**
 * @deprecated
 */
export interface IDateTimePicker {
  /** identifies field name to users & screen readers */
  label: string,
  value: string | null,
  /** (optional) if true, this prevents the onChange handler from triggering when an invalid date is provided*/
  suppressEventsForInvalidDates?: boolean,
  onChange: (date: Object | null) => void,
  /** (optional) prevent future dates from being selected if true (default is false)*/
  disableFuture?: boolean,
  /** (optional) set the minimum date & time that can be selected*/
  minDateTime?: string | undefined,
  /** (optional) set the maximum date & time that can be selected*/
  maxDateTime?: string | undefined,
  /** (optional) set the maximum date that can be selected*/
  maxDate?: string | undefined,
  /** (optional) set the time zone using the timezone code*/
  timezone?: string
}

/**
 * Old DateTimePicker
 * @param label
 * @param value
 * @param suppressEventsForInvalidDates
 * @param onChange
 * @param disableFuture
 * @param minDateTime
 * @param maxDateTime
 * @param maxDate
 * @param timezone
 * @param props
 * @constructor
 * @deprecated
 */
const DateTimePicker: FC<IDateTimePicker> =
  ({
     label,
     value,
     suppressEventsForInvalidDates = true,
     onChange,
     disableFuture = false,
     minDateTime = '01/01/1901 12:00 AM',
     maxDateTime = "",
     maxDate,
     timezone,
     ...props
  }: IDateTimePicker) => {
  const dateTimeValue = value ? moment(value) : null;

  const handleChange = (dateTimeMoment: Object | null, {validationError}: any) => {
    if (!(suppressEventsForInvalidDates && validationError)) {
      onChange(dateTimeMoment);
    }
  }

  const minDateTimeMoment = moment(minDateTime).isValid() ? moment(minDateTime) : undefined;
  const maxDateTimeMoment = moment(maxDateTime).isValid() ? moment(maxDateTime) : undefined;
  const maxDateMoment = maxDate && moment(maxDate).isValid() ? moment(maxDate) : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <MUIDateTimePicker
        label={label}
        slotProps={{textField: {variant: "standard"}}}
        value={dateTimeValue}
        onChange={handleChange}
        disableFuture={disableFuture}
        minDateTime={minDateTimeMoment}
        maxDateTime={maxDateTimeMoment}
        maxDate={maxDateMoment}
        timezone={timezone}
        sx={{
          width: '100%',
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DateTimePicker;
